import React, { useState, useEffect, useContext, useRef } from "react";
import VideoPlayer from "../../../SavedPhotos/Lightbox/VideoPlayer";
// @ts-ignore
import Swipeable from "react-swipeable";
import TagsSection from "../../../BrowseEvent/components/albums/TagsSections";
import ajax from "superagent";
import { handleSave, handleUnsave, hidePhoto } from "../../API/api";
import { addParamToURL } from "../../../../utils/BrowserHelper";
import { Album, EventType, PhotoType, VideoType } from "../types";
import {
  generateTooltipHTML,
  initializeParticipantTooltips
} from "./participantTooltip";
const GreenHiddenIcon = require("../../styles/images/GreenHide.svg");
const GreenSaveIcon = require("../../styles/images/GreenSave.svg");
const GreenDownloadIcon = require("../../styles/images/GreenDownload.svg");
const ZoomInIcon = require("../../styles/images/ZoomIn.svg");
const ZoomOutIcon = require("../../styles/images/ZoomOut.svg");
const DeleteIcon = require("../../styles/images/delete.svg");
const CheckIcon = require("../../styles/images/greenCheck.svg");
const CancelIcon = require("../../styles/images/redCancel.svg");
const RedactedIcon = require("../../styles/images/redacted.svg");
const Redactedbadge = require("../../styles/images/redactedIcon.svg");

import ConfirmDeletePhoto from "../ConfirmDeletePhoto";
import PhotoVisibilityIcon from "../PhotoVisibilityIcon";
import EyeOffIcon from "../EyeOffIcon";
import PhotoRedactions from "./PhotoRedactions";
import { ParticipantObject, RedactionSources } from "../types";
import { PhotoManagerContext } from "../index";

interface PhotoPopupProps {
  photo: PhotoType | VideoType;
  isMobile: boolean;
  onClose: () => void;
  eventName: string | null;
  eventId: number;
  albumName: string;
  mediaIndex: number;
  mediaAlbum: Array<any>;
  onNavigate: (index: number) => void;
  selectedAlbum: Album;
  fetchAlbumPhotosFunction: Function;
  photoCurrentPage: number;
  showActionTooltip: (id: number, title: string, type: string) => void;
  selectedEvent: EventType;
}

const PhotoPopup: React.FC<PhotoPopupProps> = ({
  photo,
  onClose,
  eventName,
  eventId,
  isMobile,
  albumName,
  mediaIndex,
  mediaAlbum,
  onNavigate,
  selectedAlbum,
  fetchAlbumPhotosFunction,
  photoCurrentPage,
  showActionTooltip,
  selectedEvent
}) => {
  const [loading, setLoading] = useState(false);
  const [isImgLoading, setIsImgLoading] = useState(false);
  const [showDeletePhotoModal, setShowDeletePhotoModal] =
    useState<boolean>(false);

  const [isZoomedIn, setIsZoomedIn] = useState(false);
  const [mediaTags, setMediaTags] = useState([]);
  const [hidden, setHidden] = useState(photo.hidden);
  const [saved, setSaved] = useState(false);
  const [loadedSrcs, setLoadedSrcs] = useState<Set<string>>(new Set());
  const zoomRequestRef = useRef(0);

  useEffect(() => {
    zoomRequestRef.current += 1;
    setIsImgLoading(false);
  }, [photo.id]);

  const displayedSrc = isZoomedIn ? photo.largeImg : photo.zoomImg;
  const isPhotoReady = !displayedSrc || loadedSrcs.has(displayedSrc);
  const isPlayableVideo =
    photo.videoContent && photo.videoMuxPlaybackId != null;
  const showSpinner =
    loading ||
    (!photo.flaggedForModeration && !isPlayableVideo && !isPhotoReady);

  const markLoaded = (src: string) =>
    setLoadedSrcs(prev => new Set(prev).add(src));

  const [layoutEl, setLayoutEl] = useState<HTMLDivElement | null>(null);
  const [photoAreaEl, setPhotoAreaEl] = useState<HTMLDivElement | null>(null);
  const [photoAreaBounds, setPhotoAreaBounds] = useState<{
    top: number;
    height: number;
  } | null>(null);

  useEffect(() => {
    if (!isMobile || !layoutEl || !photoAreaEl) return;

    const observer = new ResizeObserver(() => {
      const areaRect = photoAreaEl.getBoundingClientRect();
      setPhotoAreaBounds({
        top:
          areaRect.top -
          layoutEl.getBoundingClientRect().top +
          layoutEl.scrollTop,
        height: areaRect.height
      });
    });
    observer.observe(photoAreaEl);
    return () => observer.disconnect();
  }, [isMobile, layoutEl, photoAreaEl]);

  useEffect(() => {
    if (!displayedSrc || loadedSrcs.has(displayedSrc)) return;

    let cancelled = false;
    const img = new Image();
    img.src = displayedSrc;
    const settle = () => !cancelled && markLoaded(displayedSrc);
    img.decode().then(settle, settle);
    return () => {
      cancelled = true;
    };
  }, [displayedSrc]);

  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  useEffect(() => {
    const cleanup = initializeParticipantTooltips();
    return cleanup;
  }, [photo.id]);
  const context = useContext(PhotoManagerContext);

  useEffect(() => {
    if (!photo || !photo.id) return;

    const fetchTags = async () => {
      setLoading(true);
      try {
        const response = await ajax.get(`/api/v1/content_tags/${photo.id}`);
        setMediaTags(response.body.appliedTags);
      } catch (error) {
        // @ts-ignore
        toastr.error("There was an error loading tags");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (context) {
      fetch(
        `/api/v1/photos/${photo.id}/is_hidden?user_id=${context.currentUserId}`
      )
        .then(response => response.json())
        .then(data => {
          setHidden(data.is_hidden);
        });
      selectedEvent.isAuthorizedForDirectDownloads &&
        fetch(
          `/api/v1/photos/${photo.id}/is_saved?user_id=${context.currentUserId}`
        )
          .then(response => response.json())
          .then(data => setSaved(data.is_saved));
    }

    fetchTags();
  }, [photo]);

  useEffect(() => {
    const handleKeyUp = (key: { keyCode: number }) => {
      if (key.keyCode === 37) {
        if (hasPrevImage()) {
          onNavigate(mediaIndex - 1);
        }
      } else if (key.keyCode === 39) {
        if (hasNextImage()) {
          onNavigate(mediaIndex + 1);
        }
      } else if (key.keyCode === 27) {
        if (isZoomedIn) {
          setIsZoomedIn(false);
        } else {
          onClose();
        }
      }
    };

    window.document.addEventListener("keyup", handleKeyUp);
    return () => {
      window.document.removeEventListener("keyup", handleKeyUp);
    };
  }, [mediaIndex, isZoomedIn]);

  const hasPrevImage = () => {
    return mediaAlbum[mediaIndex - 1] !== undefined;
  };

  const hasNextImage = () => {
    return mediaAlbum[mediaIndex + 1] !== undefined;
  };

  const prevImage = (e: any) => {
    e.preventDefault();
    if (hasPrevImage()) {
      navigateWithLoader(mediaIndex - 1);
    }
  };

  const nextImage = (e: any) => {
    e.preventDefault();
    if (hasNextImage()) {
      navigateWithLoader(mediaIndex + 1);
    }
  };

  const leftArrow = () => {
    return (
      <a
        className="left carousel-control override-carousel"
        onClick={prevImage}
      >
        <span className="fa fa-angle-left" />
      </a>
    );
  };

  const rightArrow = () => {
    return (
      <a
        className="right carousel-control override-carousel"
        onClick={nextImage}
      >
        <span className="fa fa-angle-right" />
      </a>
    );
  };

  const navigateWithLoader = (index: number) => {
    setLoading(true);
    onNavigate(index);
    setTimeout(() => setLoading(false), 100); // Simulating load time
  };

  const toggleZoom = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isZoomedIn) {
      setIsImgLoading(true);
      const request = ++zoomRequestRef.current;
      const largeImg = photo.largeImg || "";
      const img = new Image();
      img.src = largeImg;
      img.decode().then(
        () => {
          markLoaded(largeImg);
          if (zoomRequestRef.current !== request) return;
          setIsZoomedIn(true);
          setIsImgLoading(false);
        },
        () => {
          if (zoomRequestRef.current === request) setIsImgLoading(false);
        }
      );
    } else {
      setIsZoomedIn(false);
    }
  };
  const isRedactionsPresent = photo.redactions?.length || 0;

  return (
    <>
      <div
        className="ws-photo-popup-layout"
        ref={setLayoutEl}
        style={
          photoAreaBounds
            ? ({
                "--photo-area-top": `${photoAreaBounds.top}px`,
                "--photo-area-height": `${photoAreaBounds.height}px`
              } as React.CSSProperties)
            : undefined
        }
      >
        <div className="ws-photo-popup-overlay">
          <Swipeable onSwipedLeft={nextImage} onSwipedRight={prevImage}>
            <div
              className={`ws-photo-popup-content ${
                isZoomedIn ? "zoomed-in" : ""
              }`}
              onClick={e => e.stopPropagation()}
            >
              {isMobile && !isZoomedIn && (
                <div className="ws-photo-popup-details-mobile">
                  <span>Photo Details</span>
                  <button className="ws-photo-popup-close" onClick={onClose}>
                    &times;
                  </button>
                </div>
              )}

              {showSpinner ? (
                <div
                  ref={setPhotoAreaEl}
                  className="dv-image-content geo-display-center ws-photo-popup-loading"
                >
                  <div className="loading-spinner">
                    <span className="fa fa-spinner fa-spin"></span>
                  </div>
                </div>
              ) : photo.flaggedForModeration ? (
                <div ref={setPhotoAreaEl} className="dv-image-content geo-display-center">
                  <div className="ws-flagged-overlay">
                    <EyeOffIcon className="ws-flagged-overlay__icon" />
                    <h3 className="ws-flagged-overlay__title">Awaiting confirmation</h3>
                    <p className="ws-flagged-overlay__text">Inappropriate content detected, awaiting admin confirmation.</p>
                  </div>
                </div>
              ) : isPlayableVideo ? (
                <div
                  ref={setPhotoAreaEl}
                  className="dv-image-content geo-display-center ws-video-box"
                >
                  <div className="modal-img">
                    <VideoPlayer
                      key={photo.id}
                      videoMuxPlaybackId={photo.videoMuxPlaybackId}
                      videoStartTime={photo.videoStartTime}
                    />
                  </div>
                  {!isImgLoading && (
                    <PhotoVisibilityIcon
                      photo={{ ...photo, hidden }}
                      showActionTooltip={showActionTooltip}
                    />
                  )}
                </div>
              ) : (
                <div
                  ref={setPhotoAreaEl}
                  className={`dv-image-content geo-display-center ${
                    isZoomedIn ? "zoomed" : ""
                  }`}
                >
                  <div
                    className={`dv-imgdetails-ph-manager ${
                      isZoomedIn ? "zoomed" : ""
                    }`}
                  >
                    <img
                      className={`lightbox-photo ${isZoomedIn ? "zoomed" : ""}`}
                      src={displayedSrc ?? undefined}
                      alt="Lightbox"
                    />
                    <PhotoVisibilityIcon
                      photo={{ ...photo, hidden }}
                      showActionTooltip={showActionTooltip}
                    />
                    {!loading && photo.largeImg && !photo.videoContent && (
                      <button
                        className={`zoom-toggle-button ${
                          isZoomedIn ? "zoomed" : ""
                        }`}
                        onClick={toggleZoom}
                      >
                        <img src={isZoomedIn ? ZoomInIcon : ZoomOutIcon} />
                      </button>
                    )}
                  </div>
                </div>
              )}

              {!isZoomedIn && (
                <div className="ws-photo-popup-details">
                  <div className="ws-photo-popup-det-bc">
                    <p className="grey-title">{eventName}</p>
                    <p className="grey-title grey-divider"> / </p>
                    <p className="grey-title">{albumName}</p>
                  </div>
                  <p className="ws-photo-title black-title">{photo.filename}</p>

                  <div className="ws-photo-popup-actions">
                    {photo.flaggedForModeration && (
                      <div className="ws-flagged-notice">
                        <span className="fa fa-exclamation-triangle" style={{ color: "#e6a817", marginRight: 6 }}></span>
                        This photo is flagged for content moderation review.
                      </div>
                    )}
                    {!photo.flaggedForModeration && photo.canHide && (
                      <button
                        className="geo-btn geo-btn--secondary-ghost geo-btn--caps geo-btn--small"
                        onClick={() =>
                          hidePhoto(
                            photo.id,
                            hidden ? "unhide" : "hide",
                            eventId,
                            setHidden,
                            selectedAlbum,
                            fetchAlbumPhotosFunction,
                            photoCurrentPage
                          )
                        }
                      >
                        <img src={GreenHiddenIcon} />
                        {hidden ? "Unhide" : "Hide"}
                      </button>
                    )}
                    {!photo.flaggedForModeration && selectedEvent.isAuthorizedForDirectDownloads && (
                      <>
                        <button
                          className="geo-btn geo-btn--secondary-ghost geo-btn--caps geo-btn--small"
                          onClick={() =>
                            saved && context
                              ? handleUnsave(
                                  photo.id,
                                  context.currentUserId,
                                  (val: boolean) => setSaved(val)
                                )
                              : context &&
                                handleSave(
                                  photo.id,
                                  context.currentUserId,
                                  (val: boolean) => setSaved(val)
                                )
                          }
                        >
                          <img src={GreenSaveIcon} />
                          {saved ? "Unsave" : "Save"}
                        </button>

                        <a
                          href={addParamToURL(
                            `/api/v1/photos/${photo.id}/download`,
                            "user_id",
                            context?.currentUserId
                          )}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="geo-btn geo-btn--secondary-ghost geo-btn--caps geo-btn--small"
                        >
                          <img src={GreenDownloadIcon} />
                          Download
                        </a>
                      </>
                    )}
                    {!photo.flaggedForModeration && selectedAlbum.canCurrentUserDelete && photo.canDelete && (
                      <button
                        className="geo-btn geo-btn--grey-ghost delete geo-btn--caps geo-btn--small"
                        onClick={() => setShowDeletePhotoModal(true)}
                      >
                        <img src={DeleteIcon} />
                        Delete
                      </button>
                    )}
                  </div>

                  {(photo.photographerName ||
                    photo.timeTaken ||
                    photo.country ||
                    photo.device) && <hr />}
                  {photo.photographerName && (
                    <div className="d-flex">
                      <div className="grey-detail">Uploaded by </div>
                      <div className="black-detail">
                        {photo.photographerName}
                      </div>
                    </div>
                  )}
                  {photo.timeTaken && (
                    <div className="d-flex">
                      <div className="grey-detail">Time taken </div>
                      <div className="black-detail">{photo.timeTaken}</div>
                    </div>
                  )}
                  {photo.country && (
                    <div className="d-flex">
                      <div className="grey-detail"> Location </div>
                      <div className="black-detail">{photo.country} </div>
                    </div>
                  )}
                  {photo.device && (
                    <div className="d-flex">
                      <div className="grey-detail">Device </div>
                      <div className="black-detail">{photo.device}</div>
                    </div>
                  )}
                  <hr />
                  <div className="ws-photo-action-footer">
                    {photo.canTag && (
                      <TagsSection
                        photoId={[photo.id]}
                        appliedTags={mediaTags}
                        contentTagsAPI={photo.contentTagsAPI}
                        setAddTags={false}
                      />
                    )}

                    {photo.permissions && photo.permissions.length > 0 ? (
                      <React.Fragment>
                        <div
                          className="geo-parti__perms"
                          style={{
                            marginTop: mediaTags.length > 0 ? "20px" : "0"
                          }}
                        >
                          <div className="permissions-header">Permissions</div>
                          <div className="permissions-container">
                            {photo.redacted && (
                              <div className="photo-redacted-item">
                                <img
                                  src={RedactedIcon}
                                  alt="Redacted"
                                  className="redacted-icon-small"
                                />
                                <div className="permissions-content">
                                  <div className="permission-label">
                                    Photo is redacted
                                  </div>
                                </div>
                              </div>
                            )}
                            {photo.permissions.map((permission, index) => (
                              <div
                                key={permission.label}
                                className="permissions-allowed"
                              >
                                <div className="permissions-content">
                                  <div className="permission-label">
                                    {permission.value ? (
                                      <img src={CheckIcon} />
                                    ) : (
                                      <img src={CancelIcon} />
                                    )}{" "}
                                    {permission.label}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </React.Fragment>
                    ) : null}

                    {photo.participants && photo.participants.length > 0 ? (
                      <React.Fragment>
                        <div className="geo-parti">
                          <div className="tag-heading">
                            <div className="title">People</div>
                          </div>
                          <div className="geo-parti--grid">
                            {photo.participants?.map(
                              (participant: ParticipantObject, idx: number) => {
                                const isRedacted =
                                  participant.redacted || false;
                                const isExpired =
                                  participant.permissionExpiryStatus?.status ===
                                  "expired";
                                const itemClass = `geo-parti__item ${
                                  isRedacted ? "redacted-indicator" : ""
                                } ${
                                  isExpired && !isRedacted
                                    ? "expired-indicator"
                                    : ""
                                }`.trim();
                                return (
                                  <div
                                    key={`${participant.photoURL}-${idx}`}
                                    className={itemClass}
                                    data-toggle="tooltip"
                                    data-participant-tooltip="true"
                                    data-html="true"
                                    title={generateTooltipHTML(participant)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src={participant.photoURL}
                                      alt="Participant"
                                      className="geo-parti__img"
                                    />
                                    {participant.redacted && (
                                      <img
                                        src={Redactedbadge}
                                        alt="Redacted"
                                        className="participant-redacted-icon"
                                      />
                                    )}
                                    {participant.permissionExpiryStatus &&
                                      participant.permissionExpiryStatus
                                        .status !== "valid" && (
                                        <div
                                          className={`permission-warning ${
                                            participant.permissionExpiryStatus
                                              .status === "expired"
                                              ? "expired"
                                              : "warning"
                                          }`}
                                        >
                                          {
                                            participant.permissionExpiryStatus
                                              .message
                                          }
                                        </div>
                                      )}
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </React.Fragment>
                    ) : null}

                    {isRedactionsPresent &&
                    (!photo.participants || photo.participants.length === 0) ? (
                      <React.Fragment>
                        <div className="geo-parti__perms">
                          <div className="permissions-header redaction-head">
                            Redaction
                          </div>
                          <div className="redacted-participants-container">
                            {photo.redactions?.map(
                              (redaction: RedactionSources, idx: number) => (
                                <div key={redaction.photoSourceURL}>
                                  <PhotoRedactions
                                    redactionImg={redaction.photoSourceURL}
                                    redacted={photo.redacted}
                                    redirectUrl={redaction.manageSourceURL}
                                  />
                                  {idx !=
                                    (photo.redactions?.length || 0) - 1 && (
                                    <hr className="permissions-divider" />
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </React.Fragment>
                    ) : null}

                    {photo.moderationClearance &&
                      (photo.moderationClearance.clearedBy ||
                        photo.moderationClearance.clearedOn ||
                        photo.moderationClearance.notes) && (
                      <div className="cm-clearance-note">
                        {/* <div className="cm-clearance-note__header">Content Reviewed</div> */}
                        <div className="cm-clearance-note__detail">
                          {photo.moderationClearance.clearedBy && (
                            <span>
                              Flagged content cleared by: <br /> {photo.moderationClearance.clearedBy}
                              {photo.moderationClearance.clearedOn && (
                                <> on {new Date(photo.moderationClearance.clearedOn).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}</>
                              )}
                            </span>
                          )}
                        </div>
                        {photo.moderationClearance.notes && (
                          <div className="cm-clearance-note__notes">
                            {photo.moderationClearance.notes}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {!isMobile && (
                <button className="ws-photo-popup-close" onClick={onClose}>
                  &times;
                </button>
              )}

              {isImgLoading && (
                <div className="ws-photo-popup-loading-overlay">
                  <span className="fa fa-spinner fa-spin" />
                </div>
              )}
            </div>
          </Swipeable>
        </div>
        {hasPrevImage() ? leftArrow() : null}
        {hasNextImage() ? rightArrow() : null}
        <div className="modal-backdrop fade in" />
        {showDeletePhotoModal && (
          <ConfirmDeletePhoto
            onClose={() => setShowDeletePhotoModal(false)}
            selectedMediaId={[photo.id]}
            selectedEventId={eventId || 0}
            onDeletePhotoSuccess={async () => {
              onClose();
              // First refresh album details to get the correct photosCount
              if (context?.encodedString && selectedAlbum?.id) {
                await context.refreshAlbumDetails(
                  selectedAlbum.id,
                  context.encodedString
                );
              }
              // Then refresh photos list (don't update photosCount since we just got it from album details)
              fetchAlbumPhotosFunction(selectedAlbum, photoCurrentPage, false);
            }}
            selectedAlbumId={selectedAlbum?.id || 0}
            parent="lightbox"
          />
        )}
      </div>
    </>
  );
};

export default PhotoPopup;
